import { useEffect } from "react";
import axiosInstance from "@/lib/axios";
import { clientIntegrityEndpoint } from "@/config/endpoints";
import { useAppSelector } from "@/stores/hook";
import { reportClientIntegrity } from "@/utils/clientIntegrity";

/**
 * Fires the report-only client integrity probe once a session is logged in.
 * Renders nothing. See utils/clientIntegrity.ts for what is checked.
 */
export default function ClientIntegrityHost() {
  const token = useAppSelector((state) => state.auth.token);

  useEffect(() => {
    if (!token) return;
    void reportClientIntegrity((payload) =>
      axiosInstance.post(clientIntegrityEndpoint, payload),
    );
  }, [token]);

  return null;
}
